<template>
  <!-- 店铺详情 -->
  <div class="shop-detail paddingTabbar">
    <!-- <Navbar :title="info.name"></Navbar> -->

    <!-- <van-nav-bar class="navber" fixed placeholder>
			<template #left>
				<van-icon @click="goBack" name="arrow-left" color="#fff" size="15px" />
			</template>
			<template #title>
				<span class="title">{{ info.name }}</span>
			</template>
			<template #right>
				<div class="right" @click="toEditShop">
					<span style="font-size: 12px; color: #fff; margin-left: 5px">修改信息</span>
				</div>
			</template>
		</van-nav-bar> -->

    <div
      class="shop-bg"
      style="background: linear-gradient(rgb(81, 149, 255), rgb(242, 242, 242))"
    ></div>
    <div class="clear"></div>

    <div class="shop-container">
      <div class="n" style="align-items: center" v-if="info">
        <img
          style="
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
          "
          :src="info.avatar"
          alt=""
        />
        <span style="font-weight: bold">{{ info.nickname }}</span>
        <div class="vip-box" v-if="info.user_vip_info">
          <template v-if="info.user_vip_info.vip_level == 1">
            <i class="iconfont iconhuiyuandengji" style="color: #5f3e3e"></i>
            <span>普通会员</span>
          </template>
          <template v-else-if="info.user_vip_info.vip_level == 2">
            <i class="iconfont iconhuiyuandengji"></i>
            <span>黄金会员</span>
          </template>
          <template v-else-if="info.user_vip_info.vip_level == 3">
            <i class="iconfont iconhuiyuandengji" style="color: #bd419d"></i>
            <span>钻石会员</span>
          </template>
        </div>
        <div class="vip-box" v-else>
          <template>
            <i class="iconfont iconhuiyuandengji" style="color: #d8d8d8"></i>
            <span>体验会员</span>
          </template>
        </div>
      </div>
      <div class="hr"></div>

      <!-- <div class="address" v-if="userInfo">
        <div class="left">
          <div class="block">
            所在地区：
            <span>{{ userInfo.province ? userInfo.province : "" }}</span>
            <span>{{ userInfo.city ? `- ${userInfo.city}` : "" }}</span>
            <span>{{ userInfo.area ? `- ${userInfo.area}` : "" }}</span>
          </div>
        </div>
        <div class="right">
          <a
            v-if="userInfo && userInfo.mobile"
            :href="`tel:${userInfo.mobile}`"
            class="btn"
          >
            <svg
              t="1692299096726"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4051"
              width="200"
              height="200"
            >
              <path
                d="M371.510163 833.327734l0 1.209474c-6.551319 0-11.355619 0.503948-14.177726 0.503948l-3.326054 0c-69.813539 0-126.05409-55.837393-128.002688-125.550143-1.075088-34.23484 11.288426-67.360994 34.738787-92.256005 23.450361-24.895011 55.165463-39.475895 89.400302-40.450193 0.335965 0 3.762809-0.201579 4.065177-0.201579 26.810012 0 52.511339 8.399126 74.61784 24.491853 31.009575 10.952461 62.355115-4.367546 92.961532-45.422476 30.472031-40.752562 36.888964-73.0724 19.049219-96.018814-6.34974-4.569125-12.464304-10.011759-18.511675-16.462288-1.075088-1.041492-2.049387-2.150176-2.990089-3.326054-20.023518-22.610449-31.513523-51.234672-32.420628-80.732404-1.948597-70.754242 53.821603-129.884092 124.273476-131.866286 0.335965 0 3.628423-0.067193 3.930791-0.067193 59.264237 0 111.674786 41.995632 124.575844 99.916009 10.414917 32.151856 37.02335 159.51621-90.945742 330.589619C530.354443 816.227112 415.454393 833.327734 371.510163 833.327734L371.510163 833.327734zM367.377793 768.721653c19.116412 0.436755 119.569965-2.250966 229.531329-149.672434 112.313119-150.176382 86.746178-255.501428 80.463632-275.121787-7.156056-31.412733-33.058962-52.20897-62.388712-52.20897-37.02335 1.041492-64.639677 30.404838-63.698975 65.546783 0.571141 18.646061 9.407022 32.252646 16.697463 40.315807 0.235176 0.268772 0.470351 0.537544 0.67193 0.806316 4.065177 4.401142 7.861582 7.6936 11.657988 10.146145 2.385352 1.579036 4.602721 3.46044 6.484126 5.610616 19.788342 22.30808 58.088359 84.528809-13.405006 180.110868-46.161599 61.783974-93.499076 74.718629-125.046195 74.752226-16.227112 0-32.353435-3.326054-47.908618-9.81018-2.68772-1.108685-5.241055-2.620527-7.525617-4.434739-8.029565-6.316143-21.266588-13.875357-38.736771-13.875357-19.150008 0.537544-34.839577 7.59281-46.430371 19.889132-11.624391 12.363514-17.738955 28.523434-17.235008 45.489669 0.974299 34.671594 28.892995 61.750378 63.497396 61.750378 0.167983 0 0.201579 0.033597 0.067193 0.067193 1.209474-0.201579 2.519738-0.369562 3.292458-0.436755C360.759281 767.680161 364.152528 767.948933 367.377793 768.721653L367.377793 768.721653zM515.706367 967.478582c-60.708886 0-119.603561-11.859567-175.071393-35.175542-16.428691-6.954477-24.122291-25.835713-17.201411-42.264405 6.92088-16.462288 25.835713-24.088695 42.264405-17.235008 47.471863 19.956325 97.933815 30.136066 150.008399 30.136066 213.539392 0 387.233328-173.693936 387.233328-387.233328 0-213.505795-173.693936-387.233328-387.233328-387.233328S128.473039 302.200571 128.473039 515.739963c0 73.005207 20.426676 144.095414 59.062657 205.610616 9.440618 15.118428 4.90509 35.007559-10.179741 44.481774-15.084831 9.474215-35.007559 4.938686-44.481774-10.179741-45.153704-71.862926-68.973627-154.812699-68.973627-239.912649 0-249.084495 202.654124-451.772216 451.772216-451.772216s451.772216 202.654124 451.772216 451.772216C967.444986 764.824458 764.790862 967.478582 515.706367 967.478582L515.706367 967.478582z"
                fill="#1989fa"
                p-id="4052"
              ></path>
            </svg>
          </a>
        </div>
      </div> -->
    </div>

    <div class="shop-tab" v-if="userInfo">
      <van-tabs
        v-model="active"
        color="#2F78DC"
        line-height="1px"
        line-width="64px"
      >
        <van-tab title="产品展示" name="4">
          <div class="tabs-box">
            <div class="card-box">
              <!-- <div class="title">
                <span>产品展示</span>
              </div> -->
              <div class="search-box">
                <div class="input-box">
                  <van-icon class="icon" name="search" />
                  <van-search
                    left-icon=""
                    v-model="productQuery.content"
                    class="input"
                    placeholder="产品搜索"
                    @search="onSearch"
                    @clear="onInputClear"
                  />
                </div>
              </div>
              <div class="product-list-box">
                <div
                  class="item"
                  v-for="item in goodsList"
                  :key="item.id"
                  @click="toDetail(item.id)"
                >
                  <img
                    class="product-img"
                    v-if="item.image && item.image.length > 0"
                    :src="url + item.image[0]"
                    alt=""
                  />
                  <img
                    class="product-img"
                    v-else
                    src="@/assets/image/banner1.jpg"
                    alt=""
                  />
                  <p class="product-content">
                    {{ item.content }}
                  </p>
                  <p class="product-price">¥{{ item.sale_price }}</p>
                  <!-- <div class="userinfo-box">
                    <img
                      class="avatar-img"
                      src="@/assets/image/banner.png"
                      alt=""
                    />
                    <span class="user-name">用户名</span>
                  </div> -->
                </div>
              </div>
              <div
                @click="onMore"
                class="more-btn"
                v-if="goodsList.length >= 10"
              >
                查看更多
              </div>
              <div
                style="margin: 0 auto"
                class="empty"
                v-if="goodsList.length == 0"
              >
                <van-empty image-size="100" description="暂无产品数据" />
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <div class="btns" v-if="active == 4 && isMe()">
        <!-- <router-link class="btn" :to="{ path: '/classList', query: { id: uid } }">
					<van-icon name="setting-o" />
					<span>分类管理</span>
				</router-link> -->
        <router-link
          class="btn"
          :to="{ path: '/shop/fabu', query: { id: uid } }"
        >
          <van-icon name="plus" />
          <span>添加产品</span>
        </router-link>
      </div>
    </div>

    <!-- <div class="swiper-box">
			<van-swipe class="my-swipe" :autoplay="3000" :show-indicators="true">
				<van-swipe-item v-for="(item, index) in slideList" :key="index">
					<a :href="item.link">
						<img class="banner-img" :src="url + item.cover" alt="" />
					</a>
				</van-swipe-item>
			</van-swipe>
		</div> -->
    <!-- <div class="shop-info">
			<div class="left">
				<div class="vip-box" v-if="info.service_info && info.service_info.vip_level">
					<template v-if="info.service_info.vip_level.vip_level == 1">
						<i class="iconfont iconhuiyuandengji" style="color: #5f3e3e"></i>
						<span>普通会员</span>
					</template>
					<template v-else-if="info.service_info.vip_level.vip_level == 2">
						<i class="iconfont iconhuiyuandengji"></i>
						<span>黄金会员</span>
					</template>
					<template v-else-if="info.service_info.vip_level.vip_level == 3">
						<i class="iconfont iconhuiyuandengji" style="color: #bd419d"></i>
						<span>钻石会员</span>
					</template>
				</div>
				<div class="vip-box" v-else>
					<template>
						<i class="iconfont iconhuiyuandengji" style="color: #d8d8d8"></i>
						<span>体验会员</span>
					</template>
				</div>
				<img class="avatar" v-if="info.thumb" :src="url + info.thumb" alt="" />
				<img v-else class="avatar" src="http://api.zglxgw.com/static/asset/index/images/lunbo.jpg" alt="" />
				<van-tag v-if="info.believe > 90" class="tag" color="#ff5722" text-color="#fff">金牌师傅</van-tag>
				<van-tag v-else-if="info.believe > 80 && info.believe < 90" class="tag" color="#a7a7a7"
					text-color="#fff">银牌师傅</van-tag>
				<van-tag v-else-if="info.believe < 80" class="tag" color="#7A443A" text-color="#fff">铜牌师傅</van-tag>
				<van-rate v-if="info.service_info" :value="info.service_info.comment_star" :size="12" color="#ffd21e"
					void-icon="star" void-color="#eee" />
			</div>
			<div class="right">
				<div class="title">{{ info.name }}</div>
				<div class="subtit">简介：{{ info.desc }}</div>
				<a :href="`https://apis.map.qq.com/uri/v1/search?content=${info.address}&region=${info.city}&referer=U5LBZ-JMZC6-UWSSL-EI7JM-5UYL5-PXBWX`"
					class="subtit">
					<i class="iconfont iconweizhi"></i> {{ info.address }}
				</a>
				<div class="btns">
					<a
            v-if="userInfo && userInfo.user_vip_info"
            :href="`tel:${info.phone}`"
            class="btn"
          >
            <i class="iconfont icondianhua"></i>
            <span>电话联系</span>
          </a>
          <a v-else :href="`tel:4006912808`" class="btn">
            <i class="iconfont icondianhua"></i>
            <span>电话联系</span>
          </a>
          <div class="btn" @click="toChat">
            <i class="iconfont iconxiaoxi"></i>
            <span>在线联系</span>
          </div>
				</div>
			</div>
		</div> -->

    <van-popup v-model="treeSelectShow" round position="bottom">
      <van-picker
        ref="classPicker"
        show-toolbar
        :columns="columns"
        @cancel="treeSelectShow = false"
        @confirm="onConfirm"
        value-key="name"
      />
    </van-popup>
    <!-- <Tabber></Tabber> -->
  </div>
</template>

<script>
import Navbar from "../../components/Navbar";
import Tabber from "../../components/Tabber";
import {
  indexOp,
  updateOp,
  deleteOp,
  addOp,
  showOp,
  uploadImg,
  uploadFile,
} from "../../api/index";
import base from "../../api/base";
import { wechatConfig } from "../../utils/wxConfig";
import { getUser, login } from "../../utils/login_toast";
import { loginAlert } from "../../utils/loginAlert";
import GoodsList from "../../components/GoodsList.vue";
import Storage from "../../utils/Storage.js";
export default {
  inject: ["reload"],
  components: {
    Navbar,
    Tabber,
    GoodsList,
  },
  props: {},
  data() {
    return {
      url: base.apiURL,
      loginURL: base.loginURL,
      active: "4",
      uid: "",
      info: "",
      pinglunList: "",
      userInfo: {
        id: "",
      },
      slideList: "",
      videoList: "",
      newsList: "",
      queryParam: {},
      per_page: "",
      last_page: "",
      page: "",
      productQuery: {
        content: "",
        user_id: "",
      },
      columns: [
        {
          name: "全部",
          children: [
            {
              name: "全部",
              id: "all",
            },
          ],
        },
      ],
      goodsList: [],
      goodsListLeft: [],
      goodsListRight: [],
      classValue: "",
      treeSelectShow: false,
      currentPage: 1,

      goodsShopInfo: null,
      goodsShopLoading: false,
    };
  },
  computed: {},
  created() {
    var invate_uid = this.$route.query.invate_uid;
    this.productQuery.user_id = this.$route.query.uid;
    if (invate_uid) {
      this.$cookies.set("invate_uid", invate_uid);
    }
    var code = this.getUrlKey("code");
    var state = this.getUrlKey("state");
    if (!this.$cookies.isKey("Authorization") && code) {
      login(this.getUser);
    }
    if (this.$cookies.isKey("userInfo")) {
      this.userInfo = this.$cookies.get("userInfo");
    }

    console.log("UserInfo:", this.userInfo);

    // 先设置，分享连接
    let shareInfo = {
      title: "我的店铺",
      desc: "聚制冷精英，集行业资源，方便您我他！",
      link:
        base.shareURL +
        "/shop/myShopIndex?uid=" +
        this.productQuery.user_id +
        "&tab=" +
        this.active +
        "&invate_uid=" +
        this.userInfo.id,
      img: "http://api.zglxgw.com/uploads/images/20201128/5fc1e41dbfbaf.jpg",
    };
    wechatConfig(shareInfo);

    this.uid = this.$route.query.uid;
    this.getShopDetail();
    this.getProductList();
    // this.getGoodsShopInfo();
  },
  mounted() {},
  watch: {},
  methods: {
    onMore() {
      var _this = this;
      if (_this.page == _this.last_page) {
        _this.$toast("没有更多数据了");
        return;
      }
      _this.$toast.loading({
        message: "",
        forbidClick: true,
      });
      var page = _this.page + 1;
      _this.productQuery.page = page;
      indexOp("/product/index", _this.productQuery).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.last_page = res.data.last_page;
          _this.page = res.data.current_page;
          if (res.data.data.length <= 0) {
            _this.$toast("没有更多数据了");
            return;
          }
          for (var i = 0; i < res.data.data.length; i++) {
            _this.goodsList.push(res.data.data[i]);
          }
        }
      });
    },
    isMe() {
      var uinfo = this.$cookies.get("userInfo");
      console.log(uinfo);
      if (!uinfo) {
        return false;
      }
      return uinfo.id == this.productQuery.user_id;
    },
    toDetail(id) {
      this.$router.push({
        path: "/shop/detail",
        query: {
          id: id,
        },
      });
    },
    //分类选择
    onConfirm(value) {
      var val = this.$refs.classPicker.getValues();
      console.log(val);
      this.classValue = value[0] + " / " + value[1];
      this.treeSelectShow = false;
      if (val[1].id == "all") {
        this.productQuery.cid = "";
      } else {
        this.productQuery.cid = val[1].id;
      }
      this.getProductList();
    },
    onSearch(value) {
      console.log(value);
      this.getProductList();
    },
    onInputClear() {
      this.productQuery.content = "";
      this.getProductList();
    },
    onclear() {
      this.classValue = "";
    },
    toSendProduct() {
      this.$router.push({});
    },
    //获取产品列表
    getProductList() {
      var _this = this;
      indexOp("/product/index", _this.productQuery).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          var data = res.data.data;
          _this.last_page = res.data.last_page;
          _this.page = res.data.current_page;
          _this.goodsList = data;
        }
      });
    },
    onTabChange(name) {
      var _this = this;

      this.$router.replace({
        path: "/myShop",
        query: {
          uid: this.$route.query.uid,
          tab: name,
        },
      });

      return false;
    },
    setUrl(active) {
      let tmpRoute = this.$route,
        query = tmpRoute.query,
        path = tmpRoute.path;

      query.active = active;
      console.log(tmpRoute);
      console.log("Replace:::", path, query);

      console.log(this.$route);
      this.$router.replace(
        {
          path: "/myShop",
          query: query,
        },
        (res) => {
          console.log(res);
        }
      );
    },
    //获取店铺详情
    getShopDetail() {
      var _this = this;
      _this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      var data = {
        uid: _this.uid,
      };
      showOp("/user/user_show", _this.uid).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.info = res.data;
        }
      });
    },
    //获取评论列表
    getPinglun() {
      var _this = this;
      _this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      var data = {
        uid: _this.uid,
      };
      indexOp("/order_comment/index", data).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.pinglunList = res.data.data;
        }
      });
    },
    getVideo() {
      var _this = this;
      var data = {
        uid: _this.uid,
      };
      indexOp("/video/index", data).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.videoList = res.data.data;
          // _this.getVideoposter();
        }
      });
    },
    getGoodsShopInfo() {
      var _this = this;
      indexOp("/goods_shop/shop_info?shop_uid=" + this.userInfo.id).then(
        (res) => {
          _this.goodsShopLoading = true;
          if (res && res.status == 200) {
            if (!res.data.error) {
              _this.goodsShopInfo = res.data;
            }
          }
          // this.checkOpenShop();
        }
      );
    },
    checkOpenShop() {
      var _this = this;
      if (this.active == "4") {
        if (!this.goodsShopInfo) {
          _this.$dialog
            .confirm({
              title: "提示",
              message: "你还没有申请开通店铺，不可售卖产品，是否申请0元入驻？",
              confirmButtonText: "我要入驻",
              cancelButtonText: "暂不入驻",
            })
            .then(() => {
              _this.$router.push({
                path: "/GoodsShopSettle",
                query: {},
              });
            })
            .catch(() => {
              if (_this.userInfo && _this.userInfo.identity == "2") {
                _this.active = "1";
              } else {
                _this.$router.back();
              }
            });
        }
        return false;
      }
    },
    //去对话
    toChat() {
      var _this = this;
      if (!_this.$cookies.isKey("userInfo")) {
        loginAlert();
        return;
      }
      var to_uid = _this.info.uid; //聊天对象 uid
      var form_uid = _this.$cookies.get("userInfo").id; //自己的 uid
      var data = {
        params: {
          to_uid: to_uid,
          from_uid: form_uid,
          chat_type: "normal",
        },
      };
      addOp("/im/build_chat", data).then((res) => {
        console.log(res);
        //跳转
        _this.$router.push({
          path: "/chat",
          query: {
            chat_id: res.data.chat_id,
            to_uid: to_uid,
          },
        });
      });
    },
    //获取轮播
    getSlide() {
      var _this = this;
      indexOp("/slide/index?cid=3").then((res) => {
        if (res && res.status == 200) {
          _this.slideList = res.data;
        }
      });
    },
    //获取登录返回的用户数据
    getUser(userInfo) {
      var _this = this;
      console.log(userInfo);
      _this.userInfo = userInfo;
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    goBack() {
      this.$router.go(-1);
    },
    toEditShop() {
      this.$router.push("/editShifuinfo");
    },
    toUploadVideo() {
      this.$router.push({
        path: "/upload",
      });
    },
    getVideoposter() {
      var _this = this;
      this.videoList.forEach((item) => {
        let video = document.createElement("video");
        let canvas = document.createElement("canvas");
        // video.setAttribute("crossOrigin", "anonymous"); //处理跨域
        video.setAttribute("src", _this.url + item.video_url);
        video.setAttribute("width", 350);
        video.setAttribute("height", 190);
        video.setAttribute("controls", "controls");
        video.setAttribute("autoplay", "autoplay");
        // video.currentTime = 1;
        video.addEventListener("canplay", function () {
          setTimeout(() => {
            canvas.width = video.width;
            canvas.height = video.height;
            canvas
              .getContext("2d")
              .drawImage(video, 0, 0, video.width, video.height); //绘制canvas
            var dataURL = canvas.toDataURL("image/png"); //转换为base64
            item.cover = dataURL;
            //     console.log(dataURL);
          }, 200);
        });
      });
    },
  },
};
</script>

<style scoped lang="less">
@ThemColor: #2f78dc;
.more-btn {
  width: 100px;
  display: block;
  margin: 0 auto;
  color: #666;
  font-size: 16px;
  text-align: center;
  padding-top: 15px;
  text-decoration: none;
}

.product-list-box::after {
  content: "";
  display: block;
  clear: both;
}
.product-list-box {
  display: flex;
  flex-wrap: wrap;
}
.product-list-box .item {
  width: 50%;
  // float: left;
  border-bottom: none !important;
  padding: 5px !important;
}
.product-list-box .item .product-img {
  width: 100%;
  height: 160px;
  border-radius: 15px;
  object-fit: cover;
}
.product-list-box .item .product-content {
  font-size: 14px;
  padding: 0 5px;
  display: -webkit-box; /* 必须设置此项才能生效 */
  -webkit-line-clamp: 2; /* 限制最大行数 */
  -webkit-box-orient: vertical; /* 垂直布局 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  margin-bottom: 5px;
}
.product-list-box .item .product-price {
  padding: 0 5px;
  color: red;
  font-weight: bold;
  margin-bottom: 5px;
}
.product-list-box .item .userinfo-box {
  display: flex;
  align-items: center;
}
.product-list-box .item .userinfo-box .avatar-img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 5px;
}
.product-list-box .item .userinfo-box .user-name {
  font-size: 12px;
  color: #666;
}
.btns {
  bottom: 110px !important;
}

.btns {
  position: fixed;
  right: 15px;
  bottom: 80px;

  .btn {
    height: 35px;
    width: 120px;
    border-radius: 35px;
    font-size: 14px;
    margin: 10px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: @ThemColor;
    box-shadow: 4px 6px 28px -10px rgba(79, 77, 77, 0.5);
    box-sizing: border-box;
    color: #fff;

    span {
      line-height: 1;
    }

    i {
      margin-right: 10px;
      color: #fff;
    }
  }
}

.product-list {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
}

.shop-detail .tabs-box .card-box .product-list .item {
  width: 33%;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: none;
}

.product-list .item img {
  width: 100%;
  height: 65px;
  object-fit: cover;
  margin-bottom: 5px;
}

.product-list .item span {
  font-size: 14px;
}

.search-box {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .input-box {
    width: 100%;
    position: relative;
    // background: #f2f2f2;

    .icon {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
    }

    .van-cell {
      padding: 0;
      border-radius: 35px;
      line-height: 35px;
      font-size: 14px;
    }

    .input {
      width: 100%;
      background: #f2f2f2;
      border-radius: 35px;
      height: 35px;
      border: none;
      font-size: 14px;
      padding-left: 35px;

      .van-search__content {
        background: #f2f2f2;
        padding-left: 0;
      }
    }
  }

  .type-btn {
    width: 27%;
    height: 35px;
    border-radius: 35px;
    background: #fff;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin-right: 5px;
    }
  }
}

.type {
  padding: 5px 15px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
